import { collection, getDocs, writeBatch, doc, setDoc } from 'firebase/firestore';
import { getDefaultDashboardSettings } from '../constants';

// Firestore allows at most 500 operations per batch; stay comfortably under.
const BATCH_LIMIT = 450;

const USER_COLLECTIONS = ['portfolioItems', 'timelineEvents', 'snapshots'];

// The preferences document written after a reset: factory defaults with
// onboarding re-armed. Written without merge so stray fields (liquidAmount,
// dismissed explanations, ...) are wiped too.
export const buildResetPreferences = () => ({
    ...getDefaultDashboardSettings(),
    onboardingStatus: 'pending',
    onboardingStep: 0,
});

export const deleteCollectionDocs = async (db, collectionPath) => {
    const snapshot = await getDocs(collection(db, collectionPath));
    const docs = snapshot.docs || [];
    for (let i = 0; i < docs.length; i += BATCH_LIMIT) {
        const batch = writeBatch(db);
        docs.slice(i, i + BATCH_LIMIT).forEach((d) => batch.delete(d.ref));
        await batch.commit();
    }
    return docs.length;
};

// Deletes all user data (portfolio items, timeline events, snapshots) and
// resets preferences so the account behaves like a fresh sign-up: the
// onboarding gate in App.js picks up `onboardingStatus: 'pending'` from the
// existing settings listener.
export const resetAccountData = async (db, appId, userId) => {
    if (!userId) throw new Error('resetAccountData: missing userId');
    const basePath = `artifacts/${appId}/users/${userId}`;
    for (const name of USER_COLLECTIONS) {
        await deleteCollectionDocs(db, `${basePath}/${name}`);
    }
    await setDoc(doc(db, `${basePath}/settings/dashboardPreferences`), buildResetPreferences());
};
